import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Conversation } from './useGetConversationById'

export enum ConversationType {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
}

const fetchConversations = async ({ pageParam = '0', type, scope, search, noContact }: FetchParams): Promise<PaginatedResponse<Conversation>> => {
  let url = `/conversations?page=${pageParam}`
  if (type) url += `&type=${type}`
  if (scope) url += `&scope=${scope}`
  if (search) url += `&search=${encodeURIComponent(search)}`
  if (noContact) url += '&noContact=true'
  
  const { data } = await api.get<PaginatedResponse<Conversation>>(url)
  return data
}

// Same pace as the unread badge of the menu: while the list is in front, a
// message received moves its conversation up and shows its unread pill. One
// small request per check; the list is reloaded only when a row of its first
// page changed (order, last message, unread count).
export const CONVERSATIONS_POLL_MS = 30_000

export const conversationsSignature = (firstPage: PaginatedResponse<Conversation>): string =>
  JSON.stringify([
    firstPage.metadata?.count,
    (firstPage.data ?? []).map((c) => [c.id, c.lastMessage?.createdAt, c.unreadCount, c.name]),
  ])

export const usePaginateConversations = (
  {
    type,
    scope,
    search,
    noContact,
  }: { type?: ConversationType; scope?: string; search?: string; noContact?: boolean } = {},
  options?: { live?: boolean },
) => {
  return usePaginate<Conversation>(
    'conversations',
    fetchConversations,
    { type, scope, search, noContact },
    {
      pollMs: options?.live ? CONVERSATIONS_POLL_MS : false,
      pollSignature: conversationsSignature,
    },
  )
}

